<template>
    <template v-if="encuestascurso && encuestascurso.length > 0">
        <v-list-item v-for="encuesta, index in encuestascurso" :key="encuesta.id" @click="launchEncuesta(index)"
            :disabled="encuesta.respondida || curso.notas.nota_final == null">
            <v-list-item-title>{{ encuesta.encuesta.titulo }}</v-list-item-title>
            <template v-slot:append>
                <template v-if="selectedOption === 'editar'">
                    <v-icon color="secondary" icon="mdi-file-edit"></v-icon>
                </template>
                <template v-else>
                    <v-icon color="secondary" icon="mdi-file" v-if="!encuesta.respondida"></v-icon>
                    <v-icon color="secondary" icon="mdi-file-check" v-if="encuesta.respondida"></v-icon>
                </template>
            </template>
        </v-list-item>
    </template>
    <template v-else>
        <v-list-item v-if="selectedOption === 'editar'" @click="launchEncuesta">
            <v-list-item-title>{{ t('Anadir') }} {{ t('encuesta') }}</v-list-item-title>
            <template v-slot:append>
                <v-icon color="secondary" icon="mdi-plus"></v-icon>
            </template>
        </v-list-item>
    </template>
    <v-dialog v-model="editEncuestasDialog">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ t('Editar') }} {{ t('encuestas') }}</v-toolbar-title>
                <v-btn icon @click="editEncuestasDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-title>{{ t('Encuestas_de_la_actividad') }}</v-card-title>
            <v-data-table-virtual :headers="headers_current" :items="encuestascurso" :loading="loading"
                @click:row="editEnquesta">
                <template v-slot:loading>
                    <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
                </template>
            </v-data-table-virtual>
            <v-card-title>{{ t('Anadir') }} {{ t('nueva') }} {{ t('encuesta') }}</v-card-title>
            <v-data-table-virtual :headers="headers" :items="encuestas" :loading="loading" @click:row="addEnquesta">
                <template v-slot:loading>
                    <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
                </template>
            </v-data-table-virtual>
        </v-card>
    </v-dialog>
    <v-dialog v-model="editEncuestaDialog">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ t('Editar') }} {{ t('encuesta') }}</v-toolbar-title>
                <v-btn color="primary" @click="save" prepend-icon="mdi-content-save">
                    {{ t('Guardar') }}
                </v-btn>
                <v-btn icon @click="editEncuestaDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-text-field v-model="editedEncuesta.encuesta.titulo" :label="t('Nombre')" disabled></v-text-field>
            <v-text-field v-model="editedEncuesta.encuesta.descripcion" :label="t('Descripción')"
                disabled></v-text-field>
        </v-card>
    </v-dialog>
    <v-dialog v-model="launchDialog" persistent scrollable>
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ encuestascurso[encuestaIndex].encuesta.titulo }}</v-toolbar-title>
                <v-btn icon @click="launchDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-card v-for="variable in encuestascurso[encuestaIndex].encuesta.encuesta_variables" :key="variable.id"
                    class="mb-6">
                    <v-card-title style="word-break: break-word;" class="text-wrap text-subtitle-1">{{ variable.etiqueta
                        }}</v-card-title>
                    <v-card-text v-if="variable.tipo === 'escala'"
                        class="d-flex align-center justify-center flex-column">
                        <v-rating v-model="variable.valor"></v-rating>
                    </v-card-text>
                    <v-card-text v-if="variable.tipo === 'texto'"><v-text-field v-model="variable.valor"
                            :label="t('Respuesta')" :placeholder="t('Escribe_tu_respuesta')"></v-text-field>
                    </v-card-text>
                </v-card>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" @click="submitEncuesta">{{ t('Enviar') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { axios } from '../axios';
import { useUiStore } from '@/stores/ui';
import { useEncuestasStore } from '@/stores/encuestas';

const { t } = useI18n();
const uiStore = useUiStore();
const encuestasStore = useEncuestasStore();

const props = defineProps({
    curso: {
        type: Object
    },
    encuestascurso: {
        type: Object
    },
    selectedOption: String,
    navbarra: {
        type: Boolean,
        default: true
    }
});

const encuestas = computed(() => encuestasStore.encuestas);
const loading = computed(() => encuestasStore.loadingEncuestas);
const editEncuestasDialog = ref(false);
const editEncuestaDialog = ref(false);
const editDialog = ref(false);
const launchDialog = ref(false);
const encuestaIndex = ref(null);
const snackbarText = ref('');

const headers_current = ref([
    { title: t('Nombre'), key: 'encuesta.titulo' },
    { title: t('Descripción'), key: 'encuesta.descripcion' },
    {
        title: `${t('Número_de')} ${t('variables')}`,
        key: 'encuesta.encuesta_variables.length',
    },
    { title: t('Orden'), key: 'orden' },
    { title: t('Momento'), key: 'momento' },
]);

const headers = ref([
    { title: t('Nombre'), key: 'titulo' },
    { title: t('Descripción'), key: 'descripcion' },
    {
        title: `${t('Número_de')} ${t('variables')}`,
        key: 'encuesta_variables.length'
    },
]);

const editedEncuesta = ref({
    curso: props.curso.id,
    encuesta: null,
    momento: 'final',
    orden: 0,
});

function editEnquesta(e, { item }) {
    editedEncuesta.value = {
        ...item,
    }
    editEncuestaDialog.value = true
}

function addEnquesta(e, { item }) {
    editedEncuesta.value = {
        id: null,
        curso: props.curso.id,
        encuesta: item.id,
        momento: 'final',
        orden: 0,
    }
    editEncuestaDialog.value = true
}

function save() {
    const method = editedEncuesta.value.id ? 'put' : 'post';
    const url = editedEncuesta.value.id ? `encuestacursos/${editedEncuesta.value.id}/` : 'encuestacursos/';
    axios[method](url, editedEncuesta.value)
        .then(() => {
            editDialog.value = false;
            snackbarText.value = editedEncuesta.value.titulo + ' ' + 'fue actualizado con éxito';
            uiStore.triggerSnackbar({ message: snackbarText.value, color: 'success' });
        })
        .catch(error => {
            uiStore.triggerSnackbar({ message: error, color: 'error' });
            console.error('Error saving the encuesta:', error);
        });
}

function launchEncuesta(index) {
    if (props.selectedOption == 'editar') {
        encuestasStore.fetchEncuestas();
        editEncuestasDialog.value = true;
    } else {
        encuestaIndex.value = index;
        launchDialog.value = true;
    }
}
async function submitEncuesta() {
    try {
        const idx = encuestaIndex.value;
        const encuestaCursoObj = props.encuestascurso[idx];
        const encuesta = encuestaCursoObj.encuesta; // el objeto encuesta completo
        const cursoId = props.curso.id;
        const encuestaId = encuesta.id;

        // 1. Recorremos cada variable y extraemos { variable: id, valor: valor }
        const valoresPayload = encuesta.encuesta_variables.map(variable => {
            return {
                variable: variable.variable,
                valor: variable.valor
            };
        });

        // 1.1. Validar que ningún valor esté vacío (null, undefined o '')
        const hayVacio = valoresPayload.some(v => v.valor === null || v.valor === undefined || v.valor === '');
        if (hayVacio) {
            // Mostramos un snackbar indicando que hay que rellenar todos los campos
            const mensajeError = t('Hay_que_rellenar_todos_los_campos');
            uiStore.triggerSnackbar({ message: mensajeError, color: 'error' });
            return; // Salimos para no hacer el POST
        }

        // 2. Montamos el body tal como lo espera el serializer
        const body = {
            encuesta: encuestaId,
            curso: cursoId,
            valores: valoresPayload
        };

        // 3. Hacemos POST a la ruta que creamos en Django
        await axios.post('/respuestas_encuesta/', body);

        // 4. Si todo OK:
        //   - Cerramos el diálogo
        //   - Marcamos esta encuesta como respondida (para que el icono cambie)
        //   - Mostramos snackbar de éxito
        launchDialog.value = false;
        // Marcamos localmente como respondida. Idealmente recargarías/actualizarías desde el store.
        encuestaCursoObj.respondida = true;

        snackbarText.value = t('Encuesta enviada con éxito');
        uiStore.triggerSnackbar({ message: snackbarText.value, color: 'success' });

    } catch (error) {
        // 5. Si hay error (por ej. ya respondió, validación, red…) mostramos snackbar de error
        console.error('Error al enviar la encuesta:', error);
        const msg = error.response?.data || error.message || t('Error desconocido');
        uiStore.triggerSnackbar({ message: msg, color: 'error' });
    }
}
</script>